import { create } from "src/store/store";
import { DynamicMenu, PrivateApps } from "./workflows.types";

export interface WorkflowsState {
  dynamicMenu: DynamicMenu | null,
  privateApps: PrivateApps| null,
  setDynamicMenu: (dynamicMenu: DynamicMenu) => void,
  setPrivateApps: (privateApps: PrivateApps) => void,
}

const initialState = {
  dynamicMenu: null,
  privateApps: null,
}

const useWorkflowsStore = create<WorkflowsState>()((set) => ({
  ...initialState,
  setDynamicMenu: (dynamicMenu: DynamicMenu): void => set(() => ({ dynamicMenu })),
  setPrivateApps: (privateApps: PrivateApps): void => set(() => ({ privateApps })),
}))

export default useWorkflowsStore;